const { Component } = Shopware;
const utils = Shopware.Utils;

Component.extend('acris-blog-author-create', 'acris-blog-author-detail', {

    beforeRouteEnter(to, from, next) {
        if (to.name.includes('acris.blog.author.create') && !to.params.id) {
            to.params.id = utils.createId();
            to.params.newItem = true;
        }

        next();
    },

    methods: {
        getEntity() {
            this.item = this.repository.create(Shopware.Context.api);
        },

        saveFinish() {
            this.isSaveSuccessful = false;
            this.$router.push({ name: 'acris.blog.author.detail', params: { id: this.item.id } });
        },

        onClickSave() {
            this.isLoading = true;

            this.repository
                .save(this.item, Shopware.Context.api)
                .then(() => {
                    this.isLoading = false;
                    this.createNotificationSuccess({
                        title: this.$tc('acris-blog-author.detail.titleSaveSuccess'),
                        message: this.$tc('acris-blog-author.detail.messageSaveSuccess')
                    });
                    this.$router.push({ name: 'acris.blog.author.detail', params: { id: this.item.id } });
                }).catch(() => {
                    this.isLoading = false;
                    this.createNotificationError({
                        title: this.$tc('acris-blog-author.detail.titleSaveError'),
                        message: this.$tc('acris-blog-author.detail.messageSaveError')
                    });
                });
        }
    }
});
